// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9d853601","732":"ebc6e1f8","977":"3a188370"}[chunkId] + ".chunk.js";
};